import React from 'react';

const NoMatch = () => {
    return (
        <div style={{textAlign: 'center', color: 'red', backgroundColor: 'yellow', marginTop: '100px'}}>
            <h1> Error: 404 (Not found)</h1>
        </div>
    );
};

export default NoMatch;